module.exports = __webpack_public_path__ + "img/sortBy-arrow-blue.5ed805e4.svg";